export class OrderTypeReferenceModel {
    public orderTypeCode: string;
    public orderTypeName: string;
    public statusCode: string;
}